/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The WalletControllerDtoDashboardUsageAndDestoryRequest model module.
 * @module model/WalletControllerDtoDashboardUsageAndDestoryRequest
 * @version 1.0
 */
class WalletControllerDtoDashboardUsageAndDestoryRequest {
    /**
     * Constructs a new <code>WalletControllerDtoDashboardUsageAndDestoryRequest</code>.
     * @alias module:model/WalletControllerDtoDashboardUsageAndDestoryRequest
     */
    constructor() { 
        
        WalletControllerDtoDashboardUsageAndDestoryRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>WalletControllerDtoDashboardUsageAndDestoryRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/WalletControllerDtoDashboardUsageAndDestoryRequest} obj Optional instance to populate.
     * @return {module:model/WalletControllerDtoDashboardUsageAndDestoryRequest} The populated <code>WalletControllerDtoDashboardUsageAndDestoryRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new WalletControllerDtoDashboardUsageAndDestoryRequest();

            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>WalletControllerDtoDashboardUsageAndDestoryRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>WalletControllerDtoDashboardUsageAndDestoryRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} beginDate
 */
WalletControllerDtoDashboardUsageAndDestoryRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
WalletControllerDtoDashboardUsageAndDestoryRequest.prototype['endDate'] = undefined;






export default WalletControllerDtoDashboardUsageAndDestoryRequest;

